<script setup lang="ts">
const { transparentHeader } = defineProps<{
  checkout?: Boolean
  transparentHeader?: Boolean
}>()

const rootClasses = computed(() => {
  return transparentHeader
    ? 'bg-transparent border-none backdrop-filter-none'
    : 'border-none  shadow-none transition-transform duration-500 ease-in-out'
})

const toggleClasses = computed(() => {
  return transparentHeader
    ? 'text-stone-50'
    : 'text-stone-900 hover:text-stone-900'
})
</script>

<template>
  <ClientOnly>
    <UHeader
      mode="drawer"
      :ui="{
        root: rootClasses,
        toggle: toggleClasses
      }"
    >
      <template #title>
        <NuxtLinkLocale to="/" class="pointer flex items-center gap-3">
          <NuxtImg
            :src="
              !transparentHeader ? '/images/logo-black.svg' : '/images/logo.svg'
            "
            alt="Eleven Spectacles brand logo"
            aria-label="Eleven Spectacles brand logo"
            width="18"
            height="32"
            preload
          />
        </NuxtLinkLocale>
      </template>

      <TheHeaderNav :transparentHeader="transparentHeader" />

      <template #right v-if="!checkout">
        <WishlistButton :transparentHeader="transparentHeader" />
        <ShoppingCartButton :transparentHeader="transparentHeader" />
      </template>

      <template #body>
        <TheHeaderNav :mobile="true" />
      </template>
    </UHeader>
  </ClientOnly>
</template>
